import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import axios from '~/data/http/axios'
import { alterSnackbar } from '~/data/actions/siteActions'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Hint from '~/Common-Objects/UI/Hint/Hint'
import Icons from '~/Common-Objects/UI/Icons/index'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import Toggle from '~/Common-Objects/UI/Forms/Toggle/Toggle'

export default function SubscriberTracking({ SubscriberId }) {
    const [disableOpens, setDisableOpens] = useState(false)
    const [disableClicks, setDisableClicks] = useState(false)
    const [isLoading, setIsLoading] = useState(true)
    const dispatch = useDispatch()

    const getSubscriberTracking = async () => {
        const response = await axios.get(`/subscriber/${SubscriberId}/tracking`)
        const data = response.data || {}
        setDisableOpens(data.disableOpens || false)
        setDisableClicks(data.disableClicks || false)
        setIsLoading(false)
    }

    const updateSubscriberTracking = async () => {
        try {
            const response = await axios.put(`/subscriber/${SubscriberId}/tracking`, {
                disableOpens,
                disableClicks
            })
            dispatch(alterSnackbar(true, 'Contact tracking updated'))
        } catch (e) {
            dispatch(alterSnackbar(true, 'Failed to update contact tracking'))
            getSubscriberTracking()
        }
    }

    useEffect(() => {
        getSubscriberTracking()
    }, [SubscriberId])

    return (
        <Paper className='mar-t20 mar-b0'>
            <Hint
                iconRight={<Icons icon='arrowRight' />}
                style={{ marginLeft: 0, position: 'absolute', right: 0, top: 16 }}
                target='_blank'
                href='https://transpond.io/blog/eu-email-open-tracking-consent-is-changing-how-transpond-users-can-stay-compliant/147'
            >
                Learn More
            </Hint>
            <h4>Email Tracking</h4>
            <div className='mar-b20 mar-t10'>
                Enable or disable tracking for this contact. Some countries require opt-in for tracking.
            </div>
            {isLoading ? (
                <LoadingIcons />
            ) : (
                <>
                    <Toggle
                        after='Disable Open Tracking'
                        checked={disableOpens}
                        onChange={() => setDisableOpens(!disableOpens)}
                        outerClassName='mar-b10'
                    />
                    {/* <Toggle
                after='Disable Clicks'
                checked={disableClicks}
                outerClassName='mar-b10'
                onChange={() => setDisableClicks(!disableClicks)}
            /> */}
                    <Button className='button-primary' onClick={updateSubscriberTracking}>
                        Update
                    </Button>
                </>
            )}
        </Paper>
    )
}
